import { CommonResponse, get } from './common.ts'

/**
 * (01)
 * 교과목 목록 조회
 */

// Get /majors
interface GetMajorsResponse {
  id: string
  name: string
  schoolId: string
}

export const getMajors = async (): Promise<CommonResponse<GetMajorsResponse>> => {
  return await get('/majors')
}
